import React from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createEpicMiddleware } from 'redux-observable';
import { persistStore } from 'redux-persist';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import config from 'config';
import { rootReducer, rootEpic } from 'root';
import loggerMiddleware from 'middlewares/logger';
import trackerMiddleware from 'middlewares/trackerMiddleware';

const isProduction = (process.env.NODE_ENV === 'production');

const history = createBrowserHistory();

const middlewares = [
  thunk,
  createEpicMiddleware(rootEpic),
  routerMiddleware(history),
];

if (config.enable_logs === '1') {
  middlewares.push(loggerMiddleware);
}

if (config.enable_analytics) {
  middlewares.push(trackerMiddleware);
}

// eslint-disable-next-line
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(
  applyMiddleware(...middlewares),
);

const store = createStore(
  rootReducer(history),
  enhancer,
);

store.asyncReducers = {};

const createPersistor = () => {
  // reset persisted app state before initialize
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('persist:') && !key.endsWith(config.release_version)) {
      localStorage.removeItem(key);
    }
  });

  return persistStore(store);
};

if (module.hot && !isProduction) {
  module.hot.accept('../root', () => {
    store.replaceReducer(rootReducer(history));
  });
}

if (!isProduction && config.enable_log_updates) {
  // https://www.npmjs.com/package/why-did-you-update
  const { whyDidYouUpdate } = require('why-did-you-update'); // eslint-disable-line
  whyDidYouUpdate(React);
}

const persistor = createPersistor();

export { history, persistor };
export default store;
